<template>
  <v-card class="walk-in-form" flat>
    <v-card-text>
      <v-form ref="formRef" @submit.prevent="submit">
        <v-text-field
          v-model="name"
          :label="$t('booking.your_name')"
          :rules="[requiredRule]"
          density="comfortable"
        />
        <v-text-field
          v-model="phone"
          :label="$t('booking.your_phone')"
          :rules="[requiredRule]"
          density="comfortable"
        />
        <v-text-field
          v-model="email"
          :label="$t('booking.your_email')"
          type="email"
          :rules="[requiredRule]"
          density="comfortable"
        />

        <v-btn type="submit" color="primary" block>
          {{ $t("booking.continue") }}
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { WalkInCustomerDTO } from "../../types/public-booking.type";

const { t } = useI18n();
const emit = defineEmits<{ continue: [WalkInCustomerDTO] }>();

const formRef = ref();
const name = ref("");
const phone = ref("");
const email = ref("");

const requiredRule = (value: string) => !!value?.trim() || t("field_required");

const submit = async () => {
  const { valid } = await formRef.value.validate();
  if (!valid) return;

  emit("continue", {
    name: name.value.trim(),
    phone_number: phone.value.trim(),
    email: email.value.trim(),
  });
};
</script>

<style lang="scss" scoped>
.walk-in-form {
  max-width: 420px;
  margin: 0 auto;
}
</style>
